import { createContext, useContext } from 'react';
import type { EinheitBereichKey } from '../../../../components/immobilien/einheitWidgets';
import type { EinheitBereich, EinheitDetailDaten, MietverhaeltnisRoh } from '../../../../lib/immobilien/useEinheitDetail';
import type { VerwaltungsartKurz } from '../../../../lib/immobilien/sidebarNav';
import type { MvEintrag } from '../../../../lib/immobilien/einheitDetail';

/** Gemeinsamer Zustand der Einheit-Seite für Widgets und Bereiche. */
export interface EinheitSeitenWert {
  daten: EinheitDetailDaten;
  fehler: Partial<Record<EinheitBereich, string>>;
  objektName: string;
  bezeichnung: string;
  /** „Wohneinheit“, „Gewerbe“, „Stellplatz“ … */
  artLabel: string;
  verwaltungsart: VerwaltungsartKurz | null;
  /** Hauptmieter des laufenden Mietverhältnisses (bei mehreren der am längsten wohnende) */
  aktuell: MietverhaeltnisRoh | null;
  /** alle laufenden Mietverhältnisse (mehrere Mietparteien möglich) */
  laufende: MietverhaeltnisRoh[];
  zeitstrahl: MvEintrag[];
  /** Monatliche Miete des laufenden Mietverhältnisses (heute gültiger Mietstand) */
  miete: { kalt: number; nk: number; hk: number; weitere: number; gesamt: number };
  flaeche: number;
  heute: string;
  neuLaden: (...bereiche: (EinheitBereich | 'einheit')[]) => void;
  oeffneBereich: (key: EinheitBereichKey) => void;
  /** Legacy-Formulare (Einheit, Mietverhältnis) */
  /** Einheit-Formular öffnen, optional direkt in einem Reiter */
  bearbeiteEinheit: (reiter?: 'einheit' | 'ausstattung' | 'kauf' | 'finanzierung' | 'abrechnung') => void;
  /** Mietverhältnis-Formular öffnen, optional direkt in einem Reiter */
  bearbeiteMietverhaeltnis: (m: MietverhaeltnisRoh, reiter?: 'mieter' | 'vertrag' | 'miete' | 'einzug') => void;
  /** Nach Änderungen: Seite und Sidebar aktualisieren */
  geaendert: (...bereiche: (EinheitBereich | 'einheit')[]) => void;
}

export const EinheitSeitenKontext = createContext<EinheitSeitenWert | null>(null);

export function useEinheitSeite(): EinheitSeitenWert {
  const wert = useContext(EinheitSeitenKontext);
  if (!wert) throw new Error('useEinheitSeite außerhalb der Einheit-Seite');
  return wert;
}
